import { render, staticRenderFns } from "./SportsDefaultFooter.vue?vue&type=template&id=9d2aff8e&scoped=true"
import script from "./SportsDefaultFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./SportsDefaultFooter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SportsDefaultFooter.vue?vue&type=style&index=0&id=9d2aff8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2aff8e",
  null
  
)

export default component.exports